import axios from 'axios';
import domain from '@/environment';
import SuiviIndependant from '../../models/SuiviIndependant';
const state = {
  chargementSuiviIndependant: false,
  SuiviIndependantTable: [],
  totalRowSuiviIndependant: null
};
const getters = {
  getChargementSuiviIndependant: state => state.chargementSuiviIndependant,
  getSuiviIndependantTable: state => state.SuiviIndependantTable,
  getTotalRowSuiviIndependant: state => state.totalRowSuiviIndependant
};
const mutations = {
  SET_LOADING_SUIVI_INDEPENDANT(state, payload) {
    state.chargementSuiviIndependant = payload;
  },
  SUIVI_INDEPENDANT_FILTRED(state, payload) {
    state.SuiviIndependantTable = payload.map(item =>
      SuiviIndependant.create(item)
    );
  },
  SET_TOTAL_ROW_SUIVI_INDEPENDANT(state, payload) {
    state.totalRowSuiviIndependant = payload;
  },
  UPDATE_FACTURE_SUIVI_INDEPENDANT(state, payload) {
    payload.row.update(payload.response);
  }
};
const actions = {
  async getSuiviIndependantFiltred({ commit }, payload) {
    commit('SET_LOADING_SUIVI_INDEPENDANT', true);
    try {
      const params = {
        page: payload.page,
        per_page: payload.perPage,
        year: payload.year
      };
      if (payload.switchMonth && payload.switchMonth == true) {
        params.month = payload.month;
      } else {
        if (payload.semaine != null) {
          params.semaine = payload.semaine;
        }
      }
      if (
        payload.employee_id &&
        payload.employee_id.id &&
        payload.employee_id.id != null
      ) {
        params.employee_id = payload.employee_id.id;
      }
      if (payload.validation != null) {
        params.statue = payload.validation;
      }
      if (payload.type !== null) {
        params.type = payload.type;
      }

      const response = await axios.get(domain + `/api/getAllSuivi`, {
        headers: {
          Authorization: `Bearer ${this.state.User.access_token}`
        },
        params: params
      });
      commit('SUIVI_INDEPENDANT_FILTRED', response.data.bill.data);
      commit('SET_TOTAL_ROW_SUIVI_INDEPENDANT', response.data.bill.total);
      commit('SET_LOADING_SUIVI_INDEPENDANT', false);
      return true;
    } catch (error) {
      commit('SET_LOADING_SUIVI_INDEPENDANT', false);
      return false;
    }
  },
  async updateSuiviIndependent({ commit }, payload) {
    const params = {
      column: payload.column,
      value: payload.value,
      id: payload.row.id
    };
    try {
      const response = await axios.post(domain + `/api/updateSuivi`, params, {
        headers: {
          Authorization: `Bearer ${this.state.User.access_token}`
        }
      });
      const obj = {
        response: response.data.data,
        row: payload.row
      };
      commit('UPDATE_FACTURE_SUIVI_INDEPENDANT', obj);
      return true;
    } catch (error) {
      return false;
    }
  },
  async exportExcelSuiviIndependant({ commit }, payload) {
    commit('SET_LOADING_SUIVI_INDEPENDANT', true);
    const params = {
      page: payload.page,
      per_page: payload.perPage,
      year: payload.year
    };
    if (payload.semaine != null) {
      params.semaine = payload.semaine;
    }
    if (
      payload.employee_id &&
      payload.employee_id.id &&
      payload.employee_id.id != null
    ) {
      params.employee_id = payload.employee_id.id;
    }
    if (payload.validation != null) {
      params.statue = payload.validation;
    }
    if (payload.type !== null) {
      params.type = payload.type;
    }

    try {
      const response = await axios.get(domain + `/api/EmployeeSuiviExport`, {
        params: params,
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${this.state.User.access_token}`
        }
      });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([response.data]));
      link.setAttribute(
        'download',
        'SUIVI INDEPENDANT - ' + payload.year + '.xlsx'
      );
      document.body.appendChild(link);
      link.click();
      commit('SET_LOADING_SUIVI_INDEPENDANT', false);
      return true;
    } catch (error) {
      commit('SET_LOADING_SUIVI_INDEPENDANT', false);
      return false;
    }
  }
};
export default {
  state,
  getters,
  actions,
  mutations
};
